import { render, staticRenderFns } from "./UsersStats.vue?vue&type=template&id=4986221a"
import script from "./UsersStats.vue?vue&type=script&lang=js"
export * from "./UsersStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports